<template>
  <div class="marquee-section">
    <div class="marquee-container">
      <div class="marquee-content" ref="marqueeContent">
        <div class="marquee-item" v-for="(item, index) in notices" :key="index">
          <span class="notice-text">{{ item }}</span>
        </div>
        <!-- 复制一份用于无缝滚动 -->
        <div class="marquee-item" v-for="(item, index) in notices" :key="'copy-' + index">
          <span class="notice-text">{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeNotice',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultNotices: [
        '广东用户136****5876前30秒已开通',
        '河北用户152****7666前1分钟已开通',
        '江西用户138****1796前2分钟开通',
        '浙江用户136****6856前3分钟开通',
        '上海用户180****0660前4分钟开通',
        '江苏用户159****8867前5分钟开通',
        '新疆用户131****9867前30秒开通',
        '湖北用户189****6769前1分钟开通',
        '黑龙江用户157****6623前2分钟开通',
        '四川用户177****9823前3分钟开通',
        '福建用户135****5786前5分钟开通'
      ],
      animationId: null,
      position: 0
    }
  },
  computed: {
    notices() {
      return this.config.notices || this.defaultNotices
    },
    speed() {
      return this.config.speed || 1
    }
  },
  mounted() {
    this.startMarquee()
  },
  beforeDestroy() {
    this.stopMarquee()
  },
  methods: {
    startMarquee() {
      const content = this.$refs.marqueeContent
      if (!content) return

      const animate = () => {
        const firstHalfWidth = content.scrollWidth / 2

        this.position -= this.speed

        // 当滚动完第一份内容时，重置位置
        if (Math.abs(this.position) >= firstHalfWidth) {
          this.position = 0
        }

        content.style.transform = `translateX(${this.position}px)`
        this.animationId = requestAnimationFrame(animate)
      }

      this.animationId = requestAnimationFrame(animate)
    },
    stopMarquee() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.marquee-section {
  width: 100%;
  padding: 0.5rem 0 0.4rem 0;
  margin-top: -0.32rem;
  overflow: hidden;
  position: relative;
  z-index: 5;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
  background: transparent;
}

.marquee-content {
  display: flex;
  white-space: nowrap;
  will-change: transform;
}

.marquee-item {
  flex-shrink: 0;
  padding: 0 0.2rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;

  &:first-child {
    margin-left: 0;
  }
}

.notice-text {
  font-size: 0.336rem;
  color: #ffffff;
  line-height: 1;
}
</style>
